/* eslint-disable no-undef,no-unused-vars,no-new */

import {modal, route, select, readURL, event} from '../../_base/js/Avalon'
import {app} from '../../_base/js/DOM'
import {Request} from '../../_base/js/Request'
import Swiper from 'swiper'

import '../sass/main.scss'

app(document).go().then((__params) => {
  console.log('Ready !!!')
  // Dispatch l'événement docReady pour récupérer jquery à l'exterireur
  document.dispatchEvent(new CustomEvent('docReady', {
    detail: {
      $: () => {
        return require('jquery')
      },
      app: () => {
        return app
      },
      bs: () => {
        return require('bootstrap.native/dist/bootstrap-native-v4')
      }
    }
  }))
  const url = window.location.href
  const $event = new Event('delRowEvent')
  const $eventModal = new Event('modalEvenement')
  const $basketEvt = new Event('basket-evt')
  // import('jquery.niceScroll').then(() => {
  //   $('body, .__card .__card-description .__card-inner').niceScroll({
  //     cursorcolor: 'rgba(227, 200, 50, 1)',
  //     cursorborder: 'none',
  //     cursorwidth: '5px'
  //   })
  // })
  $('.__contenu').on('click', '.__modal-menu-event', (evt) => {
    let target = $(evt.target).data('target')
    let id = $(evt.target).data('menu')
    Request.get(`/api/get-menu/${id}`).then(response => {
      let res = JSON.parse(response)
      // console.log(response)
      if (res.data !== false) {
        import('bootstrap.native/dist/bootstrap-native-v4').then(_b => {
          let modalInstance = new _b.Modal(target)
          document.querySelector(`${target} .modal-body`).innerHTML = res.data.content
          modalInstance.show()
        })
      }
    })

    // $(target).modal('toggle')
  })
  document.addEventListener('delRowEvent', () => {
    app('.__delete-row').on('click', el => {
      let row = app(el).dataset('target')
      app(row).delete(null, 0)
    })
  })
  // document.querySelector('body').classList.remove('__loading')
  let $affixEvent = new Event('affixEvent')
  if (location.pathname.substr(1) !== '') {

  }
  readURL('input[type=file].__fileImg')

  app('.__article table').addClass('table table-striped table-bordered')
  // import('@base/js/Jarallax').then(({Parallax}) => {
  //   Parallax('.jarallax')
  // })
  // import('jarallax').then(({jarallax}) => {
  //   jarallax(document.querySelectorAll('.jarallax'), {
  //     speed: 0.2
  //   })
  // })
  // route('product-designer').then(() => {
  //   require('./product-designer')
  // })
  route('').then(() => {
    import('@base/js/GoggleMap').then(({gmap}) => {
      if (app('#gmap-block').length) {
        let gmapBlock = app('#gmap-block').dataset()
        gmap('#gmap-block', gmapBlock.apikey, {
            center: {
              lat: parseFloat(gmapBlock.lat),
              lng: parseFloat(gmapBlock.lng)
            },
            zoom: parseInt(gmapBlock.zoom),
            scrollable: false,
            styles: require('@base/map_styles')[gmapBlock.style]
          }, {
            position: {
              lat: parseFloat(gmapBlock.markerlat),
              lng: parseFloat(gmapBlock.markerlng)
            },
            icon: {url: require('@base/img/marker.png')},
            draggable: true
          }
        )
      }
    })
    app('#homeslide').each(el => {
      Request.get('api/homeslides').then(response => {
        let res = JSON.parse(response)
        if (Object.keys(res.data).length > 0) {
          let slides = []
          let content = []
          let titles = []
          let bgc = []
          let anim = []
          let itemNav = []
          for (let [i, d] of res.data.entries()) {
            slides.push({src: d.image})
            content.push({txt: d.content})
            titles.push({title: d.name})
            bgc.push({backgroundColor: d.background})
            anim.push({animation: d.animation})
            itemNav.push(`<span class="item-nav item-${i}"></span>`)
          }
          document.querySelector('.nav-homeslide').innerHTML = itemNav.join('')
          import('vegas').then(vegas => {
            let matrix = (titre, str, classname, background, animation) => {
              return `
                <div class="container-fluid pl-5 pr-5 h-100">
                    <div class="row justify-content-${classname} h-100">
                        <div class="col-xs-6 col-md-4 p-4 text-white animated ${animation} h-100 d-flex" style="background-color:${background};">
                            <div class="align-self-center __slide-homeslide w-100" style="word-break: break-all;">
                                <h4 class="text-white w-100 text-center d-inline-block">${titre}</h4>
                                ${str}
                            </div>                      
                        </div>
                    </div>
                </div>`
            }
            let div = document.createElement('DIV')
            div.style.zIndex = 1000
            div.setAttribute('id', 'message-slider')
            let mainSlider = document.getElementById('main-slider')
            $(el).vegas({
              slides,
              delay: 10000,
              overlay: (parseInt(el.dataset.overlay) > 0) ? `/assets/img/overlays/0${el.dataset.overlay}.png` : false,
              timer: false,
              walk(index) {
                let className = index % 2 === 0 ? 'end' : 'start'
                if (content[index].txt.length > 0 || titles[index].title.length > 0) {
                  div.innerHTML = matrix(
                    titles[index].title,
                    content[index].txt,
                    className,
                    bgc[index].backgroundColor,
                    anim[index].animation
                  )
                  mainSlider.appendChild(div)
                  $('.item-nav').removeClass('active')
                  $('.item-nav.item-' + index).addClass('active')
                }
              }
            })

            $('.btn-homeslide._next').on('click', () => {
              $(el).vegas('next')
            })
            $('.btn-homeslide._previous').on('click', () => {
              $(el).vegas('previous')
            })
          })
        }
      })
    })


  })
  document.addEventListener('contact.event', (details) => {
    // console.log(details, 'event !!!')
    app('#form-contact').each(el => {
      import('validator').then(validator => {
        let action = app(el).attr('action')
        let data = []
        let errors = []
        for (let item of el) {
          if (item.name.length) {
            if (!Object.keys(item.value).length && item.name !== '_csrf') {
              errors.push(`Le champ ${app(item).dataset('label')} est requis`)
            }
            data[item.name] = item.value
          }
        }
        if (validator.isEmail(data['contact_email']) !== true) errors.push(`Veuillez saisir une adresse email valide`)
        let params = {}
        if (errors.length === 0) {
          import('@base/js/Request').then(({Request}) => {
            Request.post(action, data).then(response => {
              // console.log(response)
              if (response.hasOwnProperty('token')) {
                // remplacement du token
                app('input[name=_csrf]').val(response.token)
              }
              if (response.hasOwnProperty('errors')) {
                if (response.errors === true) {
                  params = {
                    text: `Une erreur est survenue lors de l'envoie du formulaire de contact`,
                    type: 'error',
                    layout: 'topCenter',
                    timeout: 5000
                  }
                } else {
                  params = {
                    text: `Message envoyé`,
                    type: 'success',
                    layout: 'topCenter',
                    timeout: 5000
                  }
                  select('.form-control', (el => {
                    el.value = ''
                  }))
                }
                import('@base/js/Notif').then(({Notif}) => {
                  Notif(params).show()
                })
              }
            }).then(() => {
              document.dispatchEvent(new Event('contact.form.send'))
            })
          })
        } else {
          params = {
            text: errors.join('<br>'),
            type: 'warning',
            layout: 'topCenter',
            timeout: 5000
          }
          import('@base/js/Notif').then(({Notif}) => {
            Notif(params).show()
          })
        }
      })
    })
  }, false)
  document.addEventListener('modalEvenement', () => {
    app('.toggle-modal-img').on('click', (el, evt) => {
      evt.stopPropagation()
      console.log('modal !!!')
      modal({
        image: el.dataset.img
      })
    })
  }, false)

  import('tiny-slider/src/tiny-slider').then(({tns}) => {
    app('.__carousel-prd').each(el => {
      // console.log(el.dataset)
      tns({
        container: el,
        items: 3,
        autoplay: true,
        mouseDrag: true,
        lazyload: true,
        slideBy: 1,
        speed: 400,
        controls: false,
        controlsContainer: false,
        nav: false,
        loop: true,
        autoplayButton: false,
        autoplayButtonOutput: false,
        gutter: 5,
        edgePadding: 5,
        autoHeight: false
        // responsive: {
        //   992: {
        //     items: parseInt(el.dataset.slidesBig) > 0 ? parseInt(el.dataset.slidesBig) : 5
        //   },
        //   768: {
        //     items: parseInt(el.dataset.slidesMedium) > 0 ? parseInt(el.dataset.slidesMedium) : 3
        //   },
        //   0: {
        //     items: parseInt(el.dataset.slidesSmall) > 0 ? parseInt(el.dataset.slidesSmall) : 1
        //   }
        // }
      })
    })
  })

  // import('tiny-slider/src/tiny-slider').then(({tns}) => {
  //   app('.__slider').each(el => {
  //     let duration = 200
  //     if (el.dataset.hasOwnProperty('duration')) {
  //       duration = parseInt(el.dataset.duration) > 0 ? parseInt(el.dataset.duration) : 5000
  //     }
  //     // console.log(el.dataset)
  //     tns({
  //       container: el,
  //       autoplayTimeout: 0,
  //       items: parseInt(el.dataset.slidesBig) > 0 ? parseInt(el.dataset.slidesBig) : 5,
  //       autoplay: true,
  //       mouseDrag: true,
  //       lazyload: true,
  //       slideBy: 'page',
  //       speed: duration,
  //       controls: false,
  //       controlsText: [`<i class="fas fa-chevron-left"></i>`, `<i class="fas fa-chevron-right"></i>`],
  //       // controlsText: ['sfdsfdfsdfds', 'peozripo'],
  //       nav: false,
  //       navContainer: el.dataset.navcontainer ? el.dataset.navcontainer : false,
  //       controlsContainer: el.dataset.controlscontainer ? el.dataset.controlscontainer : false,
  //       loop: true,
  //       autoplayButton: false,
  //       autoplayButtonOutput: false,
  //       gutter: parseInt(el.dataset.isBackground) > 0 ? 0 : 20,
  //       edgePadding: parseInt(el.dataset.isBackground) > 0 ? 0 : 30,
  //       autoHeight: false,
  //       responsive: {
  //         992: {
  //           items: parseInt(el.dataset.slidesBig) > 0 ? parseInt(el.dataset.slidesBig) : 5
  //         },
  //         768: {
  //           items: parseInt(el.dataset.slidesMedium) > 0 ? parseInt(el.dataset.slidesMedium) : 3
  //         },
  //         0: {
  //           items: parseInt(el.dataset.slidesSmall) > 0 ? parseInt(el.dataset.slidesSmall) : 1
  //         }
  //       }
  //     })
  //   })
  // })
  app('.swiper-container').each(el => {
    let btnNext = app(el.querySelector('.swiper-button-next'))[0]
    let btnPrev = app(el.querySelector('.swiper-button-prev'))[0]
    btnNext.style.backgroundImage = 'none'
    btnPrev.style.backgroundImage = 'none'
    btnNext.innerHTML = `<i class="fas fa-chevron-right fa-3x __"></i>`
    btnPrev.innerHTML = `<i class="fas fa-chevron-left fa-3x __"></i>`
    let swiper = new Swiper(el, {
      loop: true,
      slidesPerView: parseInt(el.dataset.slidesBig) > 0 ? parseInt(el.dataset.slidesBig) : 5,
      // slidesPerGroup: 2,
      // freeMode: true,
      spaceBetween: parseInt(el.dataset.isBackground) > 0 ? 0 : 20,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        992: {
          slidesPerView: parseInt(el.dataset.slidesBig) > 0 ? parseInt(el.dataset.slidesBig) : 5,
          slidesPerGroup: parseInt(el.dataset.slidesBig) > 0 ? parseInt(el.dataset.slidesBig) : 5,
          spaceBetween: parseInt(el.dataset.isBackground) > 0 ? 0 : 20,
        },
        768: {
          slidesPerView: parseInt(el.dataset.slidesMedium) > 0 ? parseInt(el.dataset.slidesMedium) : 2,
          slidesPerGroup: parseInt(el.dataset.slidesMedium) > 0 ? parseInt(el.dataset.slidesMedium) : 2,
          spaceBetween: parseInt(el.dataset.isBackground) > 0 ? 0 : 20,
        },
        576: {
          slidesPerView: parseInt(el.dataset.slidesSmall) > 0 ? parseInt(el.dataset.slidesSmall) : 1,
          slidesPerGroup: parseInt(el.dataset.slidesSmall) > 0 ? parseInt(el.dataset.slidesSmall) : 1,
          spaceBetween: parseInt(el.dataset.isBackground) > 0 ? 0 : 20,
        }
      }
    })
  })

  import('@base/js/Editor').then(({Editor}) => {
    Editor('#editor')
  })

  let ctRow = 0
  app('.__add-address').on('click', (el, evt) => {
    el.classList.add('_ok')
    Request.get('/boutique/api/add-new-fact-address', {api: true, ct: ctRow}).then(response => {
      let res = JSON.parse(response)
      if (res.data) {
        if (el.classList.contains('_ok')) {
          let div = document.createElement('DIV')
          div.classList.add('row')
          div.setAttribute('id', `row_${ctRow}`)
          div.innerHTML = res.data
          let target = app(el.dataset.target)[0]
          let firstChild = target.firstElementChild
          target.insertBefore(div, firstChild)
          ctRow++
        }
      }
    }).then(() => {
      el.classList.remove('_ok')
      document.dispatchEvent($event)
    })
  })

  // Activation de la tab-pane dans le profile client selon l'url envoyée
  let activeTab = url.substring(url.indexOf('#') + 1)
  if (url.indexOf('#') + 1 > 0) {
    app('#tabs-user-profil .tab-pane').each(el => {
      if (activeTab === app(el).attr('id')) {
        app(`#${app(el).attr('aria-labelledby')}`).addClass('active')
        el.className += ' active show'
      }
    })
  } else {
    app('#collapse-account-edit').each(el => {
      app(`#${app(el).attr('aria-labelledby')}`).addClass('active')
      el.className += ' active show'
    })
  }


  const basketSend = (form, qty, callback) => {
    let uri = form.action
    let id = uri.split('/')[uri.split('/').length - 1]
    let _csrf = form.querySelector('input[name=_csrf]').value
    Request.post(form.action, {id, _csrf, quantity: qty}, {api: true}).then(response => {
      app('input[name=_csrf').val(response.token)
      if (response.hasOwnProperty('count')) {
        app('#basket-page').each(bsk => {
          bsk.innerHTML = response.data
        })

        app('.__basket-count').each(_bc => {
          // _bc.innerHTML = (response.count > parseInt(_bc.innerHTML)) ? response.count : _bc.innerHTML
          _bc.innerHTML = parseInt(response.count)
        })
      }
      Request.get('/panier/api/get-data', {api: true}).then(res => {
        let _res = JSON.parse(res)
        if (_res.hasOwnProperty('data')) {
          app('.__basket-content').each(basket => {
            basket.innerHTML = _res.data
          })
        }
        if (typeof callback === 'function') {
          document.dispatchEvent($basketEvt)
          callback()
        }
      })
    })
  }

  document.addEventListener('basket-evt', () => {
    app('.__btn-qty').on('click', el => {
      let input = el.parentNode.querySelector('input.__input-qty')
      input.value = parseInt(input.value) + (el.dataset.qty === 'plus' ? 1 : -1)
      document.dispatchEvent(new CustomEvent('replace-basket', {
          detail: {
            form: el.parentNode.parentNode,
            qty: parseInt(input.value)
          }
        })
      )
    })
    app('.__btn-delete-from-basket').on('click', el => {
      let form = app(el.dataset.target)[0]
      let input = form.querySelector('input.__input-qty')
      input.value = 0
      document.dispatchEvent(new CustomEvent('replace-basket', {
          detail: {
            form,
            qty: parseInt(input.value)
          }
        })
      )
    })
    app('form.__add-to-basket').on('submit', (el, evt) => {
      evt.preventDefault()
      document.dispatchEvent(new CustomEvent('replace-basket', {
          detail: {
            form: el,
            qty: 1
          }
        })
      )
    })
  })

  localStorage.setItem('canChange', 1)
  document.addEventListener('replace-basket', e => {
    let canChange = localStorage.getItem('canChange')
    const form = e.detail.form
    const qty = e.detail.qty
    if (canChange === '1') {
      localStorage.setItem('canChange', 0)
      basketSend(form, qty, () => {
        localStorage.setItem('canChange', 1)
      })
    }
  }, false)

  app('.__article').each(el => {
    let fbRegex = /facebook_page\[https:\/\/www\.facebook\.com\/(.*?)\]/
    let fbMAtch = el.innerHTML.match(fbRegex)
    if (fbMAtch) {
      let _html = el.innerHTML
      let wrapper = document.createElement('div')
      wrapper.className = 'text-center w-100'
      wrapper.innerHTML = _html.replace(fbMAtch[0], `<div class="fb-page w-100" data-href="https://www.facebook.com/${fbMAtch[1]}" data-tabs="timeline" data-width="500" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="false"><blockquote cite="https://www.facebook.com/${fbMAtch[1]}" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/${fbMAtch[1]}">lien page Facebook</a></blockquote></div>`)
      el.innerHTML = wrapper.outerHTML
    }
  })

  document.dispatchEvent($basketEvt)
  document.dispatchEvent($affixEvent)
  document.dispatchEvent($event)
  document.dispatchEvent($eventModal)
  window.onscroll = () => {
    document.dispatchEvent($affixEvent)
  }

  setTimeout(() => {
    document.querySelector('#loader').className += 'animated fadeOut'
    setTimeout(() => {
      document.querySelector('body').classList.remove('__loading')
    }, 0)
  }, 0)
})
